import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import CreateRole from "./CreateRole";

const CreateWrapper = ({ handleFetchRoles }: any) => {
  const [createModal, setCreateModal] = useState(false);

  const handleShowModal = () => {
    setCreateModal(true);
  };

  const handleHideModal = () => {
    setCreateModal(false);
  };

  return (
    <>
      <button
        onClick={() => handleShowModal()}
        className="border rounded-md px-2 py-1 flex items-center"
      >
        <AiOutlinePlus />
        <span className="ml-2">New</span>
      </button>
      <CreateRole
        isVisible={createModal}
        hideModal={handleHideModal}
        handleFetchRoles={handleFetchRoles}
      />
    </>
  );
};

export default CreateWrapper;
